import { render } from "./UUIDGeneratorPage.vue?vue&type=template&id=f2d3fbaa&scoped=true"
import script from "./UUIDGeneratorPage.vue?vue&type=script&lang=js"
export * from "./UUIDGeneratorPage.vue?vue&type=script&lang=js"

import "./UUIDGeneratorPage.vue?vue&type=style&index=0&id=f2d3fbaa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2d3fbaa"]])

export default __exports__